import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { interval, map, Observable, shareReplay, startWith, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FeatureFlagDTO } from '~modules/administration/dtos/feature-flags.dto';


@Injectable({
    providedIn: 'root',
})
export class FeatureFlagsService {

    private readonly flags$: Observable<FeatureFlagDTO[]>;


    constructor(private http: HttpClient) {
        this.flags$ = interval(environment.featureFlagsRefreshInterval * 1000).pipe(
            startWith(0),
            switchMap(() =>
                this.http.get<FeatureFlagDTO[]>(`${FeatureFlagsService.getPath()}/list`)
            ),
            shareReplay(1)
        );

        // Debug
        // this.flags$.subscribe((flags) =>
        //     console.log('Flags refresh from API:', flags)
        // );
    }

    static getPath(): string {
        return `${environment.apiURL}/administration/features-flags`;
    }

    getAll() {
        return this.flags$;
    }

    isEnabled(key: string) {
        return this.getAll().pipe(
            map((flags) => {
                const flag = flags.find((flag: FeatureFlagDTO) => flag.name === key);
                return !!flag && flag.enabled;
            }),
        );
    }
}
